import React from 'react'
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'

const EtPerformanceCard = ({total=0, completed=0, rate=0}) => {
  
  // First Created - 24 Jun 2025
  // Author - Atul Pandey
  // Purpose - Display Mission Performance
  
  
  return (
    <div className="grid grid-cols-3 gap-3">
        {/* Total */}
      <div className="flex flex-col items-center justify-center p-2 border border-gray-200 rounded bg-gray-50">
        {/* <p className="text-lg text-gray-600 py-2">Total</p> */}
         <div className='py-2'><p className="text-lg text-gray-600 py-1 rounded-full px-2 bg-orange-100">Total</p></div>
        <div className="h-16 pt-4"><p className='text-4xl font-bold text-gray-800'>{total}</p></div>
      </div>

      {/* Completed */}
      <div className="flex flex-col items-center justify-center p-2 border border-gray-200 rounded bg-gray-50">
        {/* <p className="text-lg text-gray-600 py-2">Completed</p> */}
        <div className='py-2'><p className="text-lg text-gray-600 py-1 rounded-full px-2 bg-lime-400">Completed</p></div>
         <div className="h-16 pt-4"><p className='text-4xl font-bold text-lime-800'>{completed}</p></div>
      </div>

      {/* Completion Rate */}
      <div className="flex flex-col items-center justify-center p-2 border border-gray-200 rounded bg-gray-50">
        
        <div className='py-2'><p className="text-lg text-gray-600 py-1 rounded-full px-2 bg-yellow-300">Achieved</p></div>
        {/* <div className="text-2xl font-bold text-indigo-700">
          {rate ?? 0}%
        </div> */}
        <div className='flex justify-center items-center'>
            <div className='h-16 w-16 z-0 relative'>
                <CircularProgressbarWithChildren
                    value={rate}
                    circleRatio={0.75}
                    styles={{
                    path: { stroke: '#552a9a', transform: 'rotate(-135deg)', transformOrigin: 'center center' },
                    trail: { stroke: '#d6d6d6', transform: 'rotate(-135deg)', transformOrigin: 'center center' }
                    }}
                >
                    <div><p className='text-2xl font-bold text-orange-600'>{rate}%</p></div>
                </CircularProgressbarWithChildren>
            </div>
        </div>
      </div>
    </div>
  )
}

export default EtPerformanceCard